import { useTheme, useMediaQuery, Button, Box, Typography } from '@mui/material';
import LogoGrid, { Logo } from 'src/e2e-redesign/components/LogoGrid';
import ProviderDetailsDrawer from 'src/e2e-redesign/components/ProviderDetailsDrawer/ProviderDetailsDrawer';
import ThemedCard from 'src/e2e-redesign/components/ThemedCard';
import { E2eAppSettingsFormPathsI } from 'src/interfaces/application-settings.interfaces';

interface PaymentOptionApplyCardProps {
  logos: Logo[];
  drawerState: boolean;
  toggleDrawer: () => void;
  e2ePath?: E2eAppSettingsFormPathsI;
  onApply: () => void;
  multiPathsExist?: boolean;
  onGoBack?: () => void;
}

export default function PaymentOptionApplyCard({
  logos,
  drawerState,
  toggleDrawer,
  e2ePath,
  onApply,
  multiPathsExist,
  onGoBack,
}: PaymentOptionApplyCardProps) {
  const theme = useTheme();
const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <ThemedCard>
      <Typography variant="h2" sx={{ marginBottom: '20px' }}>
        Apply for Low Monthly Payments
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: '40px' }}>
        Review program details below. Keep in mind: your application may be sent to multiple payment options. Our goal
        is to connect you with the right payment option.
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'stretch', sm: 'center' },
          justifyContent: 'start',
          gap: 2,
          marginTop: '20px',
        }}
      >
        <LogoGrid logos={logos} />
      </Box>
      <Box
        sx={{
          paddingTop: 2,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: { xs: 'center', md: 'space-between' },
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box
          sx={{
            marginTop: '20px',
          }}
        >
          <Typography
            component="p"
            variant="body1"
            sx={{ paddingBottom: '20px', textDecoration: 'underline', cursor: 'pointer' }}
            onClick={toggleDrawer}
          >
            Purchase Option Details
          </Typography>
        </Box>
        <Box>
          <Button
            variant="contained"
            color="warning"
            size={isMdUp ? 'large' : 'small'}
            onClick={onApply}
            fullWidth
            sx={{ maxWidth: { xs: '100%', md: 'auto' } }}
          >
            Apply
          </Button>
          {multiPathsExist && onGoBack && (
            <Button
              type="button"
              onClick={onGoBack}
              sx={{
                color: 'text.primary',
                textDecoration: 'underline',
              }}
            >
              Back
            </Button>
          )}
        </Box>
      </Box>

      {e2ePath && (
        <ProviderDetailsDrawer
          isDrawerOpen={drawerState}
          path={e2ePath}
          toggleDrawer={toggleDrawer}
          showPathName={false}
        />
      )}
    </ThemedCard>
  );
}
